import { legacyColors } from '@ovComponents/legacyColor';

const MODEL_FILTER_INPUT_BACKGROUND = legacyColors.white;

export const MODEL_FILTER_FIELD_HEIGHT = 32;

/**
 * MUI Autocomplete adds its own small OutlinedInput padding (6px vertical on the
 * root, 2.5px vertical on the input). Those rules use higher selector specificity
 * than a plain `& .MuiOutlinedInput-root` sx block, so we target the same chain.
 */
const COMPACT_AUTOCOMPLETE_OUTLINED_SMALL =
  '& .MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall';

export const MODEL_FILTER_WRAPPER_SX = {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  height: MODEL_FILTER_FIELD_HEIGHT,
  maxHeight: MODEL_FILTER_FIELD_HEIGHT,
  overflow: 'hidden',
} as const;

export const createCompactModelFilterSx = (
  inputBackground: string = MODEL_FILTER_INPUT_BACKGROUND,
) =>
  ({
    width: '100%',
    m: 0,
    p: 0,
    display: 'flex',
    alignItems: 'center',
    height: MODEL_FILTER_FIELD_HEIGHT,
    maxHeight: MODEL_FILTER_FIELD_HEIGHT,
    overflow: 'hidden',

    '& > .MuiAutocomplete-root': {
      width: '100%',
      height: MODEL_FILTER_FIELD_HEIGHT,
      minHeight: MODEL_FILTER_FIELD_HEIGHT,
      maxHeight: MODEL_FILTER_FIELD_HEIGHT,
    },

    '& .MuiInputBase-root': {
      height: MODEL_FILTER_FIELD_HEIGHT,
      minHeight: MODEL_FILTER_FIELD_HEIGHT,
      maxHeight: MODEL_FILTER_FIELD_HEIGHT,
      backgroundColor: inputBackground,
    },

    '& .MuiFormControl-root': {
      width: '100%',
      height: MODEL_FILTER_FIELD_HEIGHT,
      minHeight: MODEL_FILTER_FIELD_HEIGHT,
      maxHeight: MODEL_FILTER_FIELD_HEIGHT,
      m: 0,
      backgroundColor: inputBackground,
    },

    [COMPACT_AUTOCOMPLETE_OUTLINED_SMALL]: {
      height: MODEL_FILTER_FIELD_HEIGHT,
      minHeight: MODEL_FILTER_FIELD_HEIGHT,
      maxHeight: MODEL_FILTER_FIELD_HEIGHT,
      padding: '0 8px !important',
      alignItems: 'center !important',
      boxSizing: 'border-box',
      fontSize: '14px',
      fontWeight: 400,
      backgroundColor: inputBackground,
      flexWrap: 'nowrap',
      gap: 0.25,
    },

    [`${COMPACT_AUTOCOMPLETE_OUTLINED_SMALL}:has(.MuiAutocomplete-tag)`]: {
      overflowX: 'auto',
      overflowY: 'hidden',
    },

    [`${COMPACT_AUTOCOMPLETE_OUTLINED_SMALL} .MuiAutocomplete-input`]: {
      padding: '0 !important',
      margin: 0,
      height: '20px !important',
      font: '400 14px/20px inherit !important',
      boxSizing: 'border-box !important',
      alignSelf: 'center !important',
      flexShrink: 0,
      minWidth: 30,
      '&::placeholder': {
        lineHeight: '20px',
        opacity: 1,
      },
    },

    [`${COMPACT_AUTOCOMPLETE_OUTLINED_SMALL}:has(.MuiAutocomplete-tag) .MuiAutocomplete-input`]:
      {
        minWidth: 24,
      },

    '& .MuiInputAdornment-root': {
      height: 'auto',
      ml: 0,
      mr: 0.25,
      alignSelf: 'center !important',
      '& .MuiSvgIcon-root': {
        fontSize: '1.125rem',
      },
    },

    '& .MuiAutocomplete-endAdornment': {
      position: 'static',
      transform: 'none',
      display: 'flex',
      alignItems: 'center',
    },

    '& .MuiAutocomplete-tag': {
      m: 0,
      mr: 0.25,
      maxHeight: 20,
      flexShrink: 0,
      alignSelf: 'center !important',
    },

    '& .MuiChip-root': {
      height: 20,
      '& .MuiChip-label': {
        fontSize: '11px',
        lineHeight: 1.2,
        px: 0.5,
      },
      '& .MuiChip-deleteIcon': {
        fontSize: '14px',
        m: 0,
      },
    },
  }) as const;

export const MODEL_FILTER_POPPER_SX = {
  '& .MuiAutocomplete-option': {
    minHeight: 36,
    py: 0.75,
    px: 1.5,
    fontSize: '14px',
    lineHeight: 1.4,
  },
  '& .MuiAutocomplete-listbox': {
    py: 0.5,
  },
} as const;
